module.exports = __webpack_public_path__ + "static/media/Data.c43c2a04.svg";